<article class="order">
  <header class="d-flex justify-content-between g-g">
    <h1 class="order-title">{{ order.title }}</h1>

    <div class="order-actions">
      <div class="open-order-btn" (click)="openOperationItemModal()">
        <i class="fa-solid fa-circle-info"></i>
      </div>

      <div
        class="open-logs-btn"
        [oaiboxAuthorizedRoles]="[UserRole.CTO]"
        (click)="openOrderLogsModal()"
      >
        <i class="fa-solid fa-file-lines"></i>
      </div>

      <div
        class="delete-order-btn"
        [oaiboxAuthorizedRoles]="[UserRole.CTO]"
        (click)="openDeleteOrderModal()"
      >
        <i class="fa-solid fa-trash"></i>
      </div>
    </div>
  </header>

  <section class="order-info">
    <div class="d-flex justify-content-between">
      <div>
        <span>{{ order.startDate | date: "yyyy-MM-dd" }}</span>
        <div class="under-label">Start Date</div>
      </div>
      <div>
        <span [class.overdue-date]="dueDateIsOverdue">
          {{ order.dueDate | date: "yyyy-MM-dd" }}
        </span>
        <div class="under-label">Due Date</div>
      </div>
    </div>

    <div class="d-flex flex-column">
      <span class="fw-bold">{{ order.customerName }}</span>
      <span>{{ order.customerEmailAddress }}</span>
      <div class="under-label">Customer</div>
    </div>

    @if (order.onPremInstallation) {
      <span class="fw-bold">On Premises Installation</span>
    }

    @if (order.comments) {
      <em class="fw-bold">{{ order.comments }}</em>
    }
  </section>

  @if (order.bom) {
    <section class="bill-of-materials">
      <header>
        <span>Bill of Materials</span>
        <div class="d-flex align-items-center g-g">
          <span>{{ order.bom | billOfMaterialsProgress }}</span>
          <button
            type="button"
            class="collapsed-toggle"
            (click)="bomIsExpanded = !bomIsExpanded"
          >
            <i
              class="fa-solid"
              [ngClass]="bomIsExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"
            ></i>
          </button>
        </div>
      </header>

      <oaibox-expandable [expanded]="bomIsExpanded">
        <ul class="bill-of-materials-items-list">
          @for (item of order.bom; track item.name) {
            <li class="bill-of-materials-item">
              <span>{{ item.quantity + "x " + item.name }}</span>
              <div class="stock-check-buttons">
                <button
                  type="button"
                  [class.not-available]="!item.isAvailable"
                  (click)="updateOrderBomItem(item, false)"
                >
                  Not Available
                </button>

                <button
                  type="button"
                  [class.available]="item.isAvailable"
                  (click)="updateOrderBomItem(item, true)"
                >
                  Available
                </button>
              </div>
            </li>
          }
        </ul>
      </oaibox-expandable>
    </section>
  }
</article>

<footer class="d-flex">
  @if (
    order.orderType !== OrderType.AWAITING_PROCUREMENT &&
    order.orderType !== OrderType.INTEGRATING_AND_TESTING
  ) {
    <button
      class="tenant-assignment-button"
      (click)="openOrderTenantAssignmentModal()"
    >
      <i class="fa-solid fa-building-magnifying-glass"></i>
      Assign Tenants
    </button>
  }

  @if (
    order.orderType !== OrderType.AWAITING_PROCUREMENT &&
    order.orderType !== OrderType.INTEGRATING_AND_TESTING &&
    order.orderType !== OrderType.PACKING
  ) {
    <button
      class="tracking-details-button"
      (click)="openOrderTrackingDetailsConfigurationModal()"
    >
      <i class="fa-solid fa-truck-fast"></i>
      Add Tracking Details
    </button>
  }
</footer>
